// Shared constants used across pages
export const KETUNAAN_LIST = [
  "A - Tuna Netra",
  "B - Tuna Rungu",
  "C - Tuna Grahita Ringan",
  "C1 - Tuna Grahita Sedang",
  "D - Tuna Daksa Ringan",
  "D1 - Tuna Daksa Sedang",
  "E - Tuna Laras",
  "F - Tuna Wicara",
  "H - Hiperaktif",
  "I - Cerdas Istimewa",
  "J - Bakat Istimewa",
  "K - Kesulitan Belajar",
  "N - Narkoba",
  "P - Down Syndrome",
  "Q - Autis",
];

export const KELAS_LIST = ["TK", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

export const RUANGAN_LIST = ["Mahoni", "Cendana", "Akasia", "Cemara", "Pinus", "Beringin", "Cempaka", "Gaharu"];

export const FASE_LIST = ["Fase A", "Fase B", "Fase C", "Fase D", "Fase E", "Fase F"];

// Ekskul & Progsus jenis
export const EKSKUL_LIST = [
  "Ekskul Pramuka",
  "Ekskul Lari",
  "Ekskul Boccee",
  "Ekskul Senam Ritmik",
  "Ekskul Lempar Turbo",
  "Ekskul Catur",
  "Ekskul Melukis",
  "Ekskul Menyanyi",
  "Ekskul Angklung",
  "Ekskul Menari",
  "Ekskul Pantomim",
  "Ekskul Keterampilan",
  "Ekskul Desain Grafis",
  "Ekskul Bahasa Inggris",
  "Ekskul TIK",
];

export const PROGSUS_LIST = [
  "Progsus Pengembangan Interaksi Sosial, Komunikasi dan Prilaku",
  "Progsus Pengembangan Diri",
  "Progsus Pengembangan Orientasi, Mobilitas, Sosial, dan Komunikasi",
  "Progsus Pengembangan Komunikasi, Persepsi, Bunyi dan Irama",
];

export const EP_ALL = [...EKSKUL_LIST, ...PROGSUS_LIST];

// Absensi Siswa
export const ABSENSI_STATUS = [
  { v: "hadir", label: "Hadir", cls: "bg-emerald-100 text-emerald-900 border-emerald-300", badge: "H" },
  { v: "sakit", label: "Sakit", cls: "bg-sky-100 text-sky-900 border-sky-300", badge: "S" },
  { v: "izin", label: "Izin", cls: "bg-amber-100 text-amber-900 border-amber-300", badge: "I" },
  { v: "alfa", label: "Alpa", cls: "bg-rose-100 text-rose-900 border-rose-300", badge: "A" },
  { v: "bdr", label: "BDR", cls: "bg-violet-100 text-violet-900 border-violet-300", badge: "B" },
];
export const ABSENSI_LABEL = Object.fromEntries(ABSENSI_STATUS.map((s) => [s.v, s.label]));
// Legacy alias so old records display sensibly
ABSENSI_LABEL.tidak_hadir = "Tidak Hadir";

export const EP_TAHUN = [2026, 2027, 2028, 2029, 2030];

export const EP_SEMESTER = [
  { v: "tengah_semester_1", label: "Tengah Semester I" },
  { v: "akhir_semester_1", label: "Akhir Semester I" },
  { v: "tengah_semester_2", label: "Tengah Semester II" },
  { v: "akhir_semester_2", label: "Akhir Semester II" },
];

export const epSemesterLabel = (v) => (EP_SEMESTER.find((s) => s.v === v)?.label || v);
